module.exports = __webpack_public_path__ + "media/images/hero/glyph-d3-b8fb63780011a42bd1f2039a80407cd2.svg";